import React, { Component } from "react";
import { Row, Column } from "react-foundation";
import { Field, reduxForm, formValueSelector, change } from "redux-form";
import { connect } from "react-redux";
import _ from "lodash";

import "css/PostCode.css";

import InputError from "../../components/InputError";
import ThemeButton from "./../../components/ThemeButton";
import Autocomplete from "../../components/Autocomplete";
import Logo from "components/Logo";

import { saveContactDetails, lookupInstallers, lookupAddress } from "../../actions/enquiry";

const FormFieldWithAutocomplete = ({ input, meta, addresses, ...otherProps }) => {
    return (
        <label className="SimpleFormField">
            <Autocomplete
                suggestions={addresses.map(address=>address.formatted_address)}
                {...input}
                {...otherProps}
            />
        </label>
    );
};

class Postcode extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null
        };

        this.lookupInstallers = this.lookupInstallers.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
        this.lookupAddress = _.debounce(this.lookupAddress.bind(this), 500, {
            leading: false,
            trailing: true
        });
    }

    lookupInstallers(values) {

        let addressData = this.props.addresses.filter(
            item => item.formatted_address === values.postcode
        )[0];
        if (!addressData) addressData = this.props.addresses[0];


        this.props.dispatch(change("postcode", "postcode", addressData.formatted_address));
        const ukPostcodeRegex = /([A-Z]{1,2}\d{1,2}[A-Z]?\s*\d[A-Z]{2})/i;
        const postcodeMatch = addressData.formatted_address.match(ukPostcodeRegex);
        const postcodeOnly = postcodeMatch ? postcodeMatch[1].toUpperCase() : addressData.formatted_address;
        sessionStorage.setItem("customerPostcode", postcodeOnly);

        this.props.lookupInstallers(
            addressData.formatted_address,
            addressData.geometry.location.lat,
            addressData.geometry.location.lng,
            resultCount => {
                if (!resultCount) {
                    this.setState({ error: "No Installers found near this address" });

                    return;
                }

                this.props.saveContactDetails(values, () => {
                    this.props.history.push("/GetQuote/Installers");
                });
            }
        );
    }

    lookupAddress() {
        this.props.lookupAddress(this.props.postcode);
    }

    handleOnChange() {
        this.setState({ error: null });
        this.lookupAddress();
    }

    render() {
        return (
            <div className="PostCode">
                <Row className="top-padding-page">
                    <Column
                        small={12}
                        medium={10}
                        large={8}
                        centerOnSmall
                        style={{ maxWidth: 450 }}
                    >
                        <Logo topLeft={true} />

                        <h3>{"Find your local installer"}</h3>
                        <p>
                            <strong>
                                {"Like what you've seen and just want to get your quote."}
                            </strong>
                            <br />
                            {
                                "We're here to help you find a local, trusted installer for all of your requirements for windows, doors and conservatories."
                            }
                        </p>
                    </Column>
                </Row>

                <form onSubmit={this.props.handleSubmit(this.lookupInstallers)} autoComplete="off">
                    <Row style={{ maxWidth: 450 }}>
                        <Column medium={8}>
                            <Field
                                name="postcode"
                                placeholder="Enter your full postcode"
                                component={FormFieldWithAutocomplete}
                                onChange={this.handleOnChange}
                                addresses={this.props.addresses}
                            />
                        </Column>

                        <Column medium={4}>
                            <ThemeButton
                                disabled={!this.props.postcode || !this.props.addresses.length}
                            >
                                Find Installers
                            </ThemeButton>
                        </Column>

                        <Column large={12}>
                            <InputError metas={{ error: this.state.error, touched: true }} />
                        </Column>
                    </Row>
                </form>
                <div className="postcode-map-container">
                    <div className="postcode-map" />
                    <div className="postcode-button-row" />
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    let valueSelector = formValueSelector("postcode");
    let postcode = valueSelector(state, "postcode");

    return { postcode, addresses: state.GoogleAddressLookup };
};

const validate = values => {
    let error = {};
    if (!values.postcode) error.postcode = "Required";

    return error;
};

export default connect(mapStateToProps, { lookupInstallers, saveContactDetails, lookupAddress })(
    reduxForm({
        form: "postcode",
        validate
    })(Postcode)
);



// WEBPACK FOOTER //
// ./src/containers/QuoteForm/Postcode.js